import React from 'react';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>Monxuan</h4>
            <a href="#about">Про нас</a>
            <a href="#contact">Контакти</a>
            <a href="#blog">Блог</a>
            <a href="#careers">Кар'єра</a>
          </div>
          
          <div className="footer-col">
            <h4>Магазин</h4>
            <a href="#shop">Всі товари</a>
            <a href="#promotions">Акції</a>
            <a href="#new">Новинки</a>
            <a href="#bestsellers">Бестселери</a>
          </div>
          
          <div className="footer-col">
            <h4>Допомога</h4>
            <a href="#shipping">Доставка та оплата</a>
            <a href="#returns">Повернення</a>
            <a href="#faq">FAQ</a>
            <a href="#privacy">Політика конфіденційності</a>
          </div>
          
          <div className="footer-col">
            <h4>Зв'язок</h4>
            <a href="tel:+380988141025">Директор +380988141025</a>
            <a href="tel:+380666438285">Менеджер по продажам  +380666438285</a>
            <p>Пн-Нд: 8:00 - 20:00</p>
            <div className="social-links">
              <a href="#facebook" aria-label="Facebook">📘</a>
              <a href="https://www.instagram.com/monxuan.ua?igsh=bjhkZDBpbnRpeTI3" aria-label="Instagram">📷</a>
              <a href="#telegram" aria-label="Telegram">✈️</a>
            </div>
          </div>
        </div>
        
        <div className="copyright">
          &copy; 2024 Monxuan Ukraine. Всі права захищені.
        </div>
      </div>
    </footer>
  );
};

export default Footer;